export const EyeIcon = ({
  strokeColor = "var(--color-icon-bright)",
  _className,
  size = "16",
  ...props
}: any) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
    <g id="vuesax/outline/eye">
      <g id="eye">
        <path
          className={_className}
          id="Vector"
          d="M7.99995 10.8866C6.40661 10.8866 5.11328 9.59328 5.11328 7.99995C5.11328 6.40661 6.40661 5.11328 7.99995 5.11328C9.59328 5.11328 10.8866 6.40661 10.8866 7.99995C10.8866 9.59328 9.59328 10.8866 7.99995 10.8866ZM7.99995 6.11328C6.95995 6.11328 6.11328 6.95995 6.11328 7.99995C6.11328 9.03995 6.95995 9.88661 7.99995 9.88661C9.03995 9.88661 9.88661 9.03995 9.88661 7.99995C9.88661 6.95995 9.03995 6.11328 7.99995 6.11328Z"
          fill={strokeColor}
        />
        <path
          className={_className}
          id="Vector_2"
          d="M8.00022 14.013C5.49355 14.013 3.12688 12.5463 1.50021 9.99966C0.793548 8.89966 0.793548 7.10633 1.50021 5.99966C3.13355 3.45299 5.50022 1.98633 8.00022 1.98633C10.5002 1.98633 12.8669 3.45299 14.4935 5.99966C15.2002 7.09966 15.2002 8.893 14.4935 9.99966C12.8669 12.5463 10.5002 14.013 8.00022 14.013ZM8.00022 2.98633C5.84688 2.98633 3.78688 4.27966 2.34688 6.53966C1.84688 7.31966 1.84688 8.67966 2.34688 9.45966C3.78688 11.7197 5.84688 13.013 8.00022 13.013C10.1535 13.013 12.2135 11.7197 13.6535 9.45966C14.1535 8.67966 14.1535 7.31966 13.6535 6.53966C12.2135 4.27966 10.1535 2.98633 8.00022 2.98633Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
